import { Image } from '@mantine/core'
import { useIntl } from 'react-intl'
import ImagePlaceholder from '@/assets/image-placeholder.png'
import { VlmResult } from '@/types/vlm'

type VlmResultThumbnailProps = {
  result: VlmResult
}

/** Preview frame. `thumbnail_url` is absent when no media was stored and expires
 * after ~15 min; both fall back to the placeholder via `fallbackSrc`. */
export const VlmResultThumbnail = ({ result }: VlmResultThumbnailProps) => {
  const intl = useIntl()

  return (
    <Image
      w={96}
      h={54}
      fit="cover"
      radius="sm"
      alt={intl.formatMessage({ id: 'vlm.results.fields.preview' })}
      src={result.thumbnail_url || ImagePlaceholder}
      fallbackSrc={ImagePlaceholder}
      styles={(theme) => ({
        root: {
          outline: `1px solid ${theme.colors.dark[3]}`,
          flexShrink: 0
        }
      })}
    />
  )
}
